import { Props_SnippetContent } from './Content.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetContent = (props: Props_SnippetContent) => {
    const { heading, repeatable_link, paragraph, linkProps } = props
    
    const classHeadingVisibility: string = heading.visibility?.value ? ` snippet-content__heading--${heading.visibility.value}` : ''
    const contentAlignmentClass: string = paragraph.alignment?.value ? `snippet-content__content--${paragraph.alignment.value}` : ''
    const headingAlignmentClass: string = heading.alignment?.value ? ` snippet-content__heading--${heading.alignment.value}` : ''
    const linkAlignmentClass: string = linkProps.alignment?.value ? `snippet-content__link-container--${linkProps.alignment.value}` : ''

    return (
        <section className="snippet-content">
            <div className="snippet-content__container">
                <h2 className={`snippet-content__heading${classHeadingVisibility}${headingAlignmentClass}`}>{heading?.content?.value}</h2>
                <div className={`snippet-content__content ${contentAlignmentClass}`}>
                    {paragraph.text.value && Legacy_CompileMarkdown(paragraph?.text?.value)}
                </div>
                   <div className={`snippet-content__link-container ${linkAlignmentClass}`}>
                       {repeatable_link.map(({linkTarget, linkText, linkHref, linkStyle}, index) => {
                           return (
                               <SnippetLink
                                   key={`link-${linkHref} ${index}`}
                                   linkStyles={linkStyle?.value}
                                   className="snippet-content__link"
                                   url={linkHref?.value}
                                   openInNewTab={linkTarget?.value}
                               >
                                   {linkText?.value}
                               </SnippetLink>
                           );
                       })}
                   </div>
               
            </div>
        </section>
    )}

export default SnippetContent
